export class HistogrammeRecolte {
    static jsonMap = {
        quantitePrevisionInitiale: 'quantitePrevisionInitiale',
        quantiteDernierePrevision: 'quantiteDernierePrevision',
        quantiteRecolte: 'quantiteRecolte'
    };

    quantitePrevisionInitiale: number = undefined;
    quantiteDernierePrevision: number = undefined;
    quantiteRecolte: number = undefined;
}
